import React from 'react';
import ForgotPasswordForm from '../components/Form/ForgotPasswordForm';
import SEOHead from '../components/SEOHead';

const ForgotPasswordPage = () => {
  return (
    <>
      <SEOHead
        title='Forgot Password | LB Visible'
        description='Reset'
        noIndex
      />
      <div>
        <ForgotPasswordForm />
      </div>
    </>
  );
};

export default ForgotPasswordPage;
